import '../index.css';
var styles = {
  "chipsGroup": "bp_chips_group_module_chipsGroup--61ede"
};
export { styles as default };